module.exports = {
  MessageBox: {
    Api: {
      Request: {
        Relogin: '账号未登录或已离线，请登录。',
        ErrorMsg: '错误信息: &nbsp;&nbsp;',
        NetworkError: '网络错误: &nbsp;&nbsp;'
      }
    },
    Button: {
      Confirm: '确定',
      Cancel: '取消',
      Close: '关闭'
    }
  },
  Component: {
    PageHandler: {
      Next: '下一页',
      Previous: '上一页',
    },
    AlertConfirm: {
      Prompt: '提示',
      SelectQuantity: '请选择数量',
      Confirm: '确定',
      Cancel: '取消',
    }
  },
  Layout: {
    Header: {
      UserCenter: '个人中心',
      Cart: '购物车',
      Address: '管理地址',
      Order: '订单',
      Logout: '登出',
      Login: '登录',
      get_points:'获取积分',
      points_record:'积分记录',
    },
    Menu: {
      HomePage: '首页',
      Products: '产品',
      Solutions: '案例',
      Training: '培训',
      Resources: '资源',
      AboutUs: '简介',
      Contact: '联系我们',
      WifiDesign: 'WIFI设计',
    },
    Footer: {
      Product: '产品',
      Solutions: '案例',
      Training: '培训',
      CourseInfo: '课程信息',
      CourseSchedule: '课程时间表',
      Resources: '资源',
      Everyday: '周一至周日',
      ContactUs: '联系我们',
      Tel: '0755-82642594'
    }
  },
  User: {
    UserCenter: {
      UserName: '用户名',
      Account: '账号',
      Change: '点击修改',
      Password: '密码',
      Country: '国家',
      SelectCountry: '请选择国家',
      Province: '省份',
      SelectProvince: '请选择省份',
      Points: '积分',
      Redeem: '兑换礼品',
      ContactSales: '联系销售',
      Phone: '电话',
      Wechat: '微信',
      Save: '保存',
      AdjustAvatar: '头像截取',
      Cancel: '取消',
      Confirm: '确定',
      taobaoid:'淘宝id',
      jdid:'京东id',
      taobaoid_exists:'淘宝id已存在',
      jdid_exists:'京东id已存在',
      taobaoid_input:'请输入淘宝id,注意绑定后不能修改',
      jdid_input:'请输入京东id，注意绑定后不能修改',
      succ:'操作成功',
      order_id_required:"请输入交易号",
    },
    ChangePhone: {
      ModifyAccount: '修改账号',
      VerCode: '验证码',
      VCpholder: '请输入验证码',
      SendCode: '发送验证',
      NewAccount: '新账号',
      NewAccpholder: '请输入账号',
      Back: '返回',
      Save: '保存',
      Next: '下一步',
      AccountInvalid: '请检查账号格式是否有误',
      TimeResend: '秒后重发',
      Empty: '请确认输入内容不为空',
      OldSuccess: '原账号验证成功！',
      ChangeSuccess: '新账号修改成功！',
    },
    ChangePwd: {
      ChangePassword: '修改密码',
      OldPassword: '原密码',
      OldPwdPholder: '请输入您的原密码',
      NewPwd: '新密码',
      NewPwdPholder: '请输入您的新密码',
      ConfirmPwd: '确认密码',
      Back: '返回',
      Save: '保存',
      Next: '下一步',
      Empty: '请确认输入内容不为空',
      OldSuccess: '密码验证成功！',
      EnterNewPwd: '请输入新密码',
      PwdNotMatch: '确认密码不一致！',
      ChangeSuccess: '新密码设置成功！',
    },
    ForgotPwd: {
      Forgot: '找回密码',
      ID: '账号',
      IDph: '手机号码/邮箱',
      Vercode: '验证码',
      VCph: '请输入验证码',
      SendVC: '发送验证',
      NewPwd: '新密码',
      NPwdph: '请输入新密码',
      Cpwd: '密码确认',
      Cpwdph: '请输入确认密码',
      Save: '保存',
      Next: '下一步',
      TimeResend: '秒后重发',
      Empty: '请确认输入内容不为空',
      VerSuccess: '手机验证成功！',
      PwdNotMatch: '确认密码不一致！',
      Success: '密码已找回，现可用新密码登录！',
    }
  },
  Gift: {
    GiftCenter: {
      Search: '搜索',
      UserCenter: '个人中心',
      GiftCenter: '礼品中心',
      Category: '类目',
      All: '全部',
      Details: '详情',
      MyGift: '我的礼品',
      PointsRecord: '积分记录',
      CurrentPoints: '当前积分',
      Total: '共',
      Gifts: '件礼品',
      TotalPages: '共',
      CurrentPages: '当前第',
      Pages: '页',
      Points: '积分',
      Redeem: '立即兑换',
      ConfirmGift: '确认礼品',
      SelectAddress: '请选择收货地址',
      ManageAddress: '管理地址',
      AddAddress: '新增地址',
      ClickSelectAddress: '点击选择地址',
      DefaultAddress: '默认地址',
      Cancel: '取消',
      Confirm: '确认',
      ConfirmExchange: '是否确认兑换？',
      ConfirmRedeem: '是否确认兑换？此礼品可直接兑换！',
      RedeemSuccess: '兑换成功！礼品会在45日内发出。',
      lp:'礼品',
      remark:'有效期内礼品不会变动',
    },
    GiftDetail: {
      UserCenter: '个人中心',
      GiftCenter: '礼品中心',
      GiftDetail: '礼品详情',
      Points: '积分',
      CurrentPoint: '你的当前积分',
      Type: '类型',
      Desc: '描述',
      Redeem: '点击兑换',
      ConfirmGift: '确认礼品',
      SelectAddress: '请选择收货地址',
      ManageAddress: '管理地址',
      AddAddress: '新增地址',
      ClickSelectAddress: '点击选择地址',
      DefaultAddress: '默认地址',
      Cancel: '取消',
      Confirm: '确认',
      Physical: '实体礼物',
      Virtual: '虚拟礼物',
      ConfirmExchange: '是否确认兑换？',
      ConfirmRedeem: '是否确认兑换？此礼品可直接兑换！',
      RedeemSuccess: '兑换成功！礼品会在45日内发出。',
    },
    MyGift: {
      UserCenter: '个人中心',
      GiftCenter: '礼品中心',
      MyGift: '我的礼品',
      GiftName: '礼品名称',
      GiftPoint: '礼品积分',
      RedeemTime: '兑换时间',
      Status: '处理情况',
      Unprocessed: '未处理',
      ViewLogistic: '查看物流',
      ViewNote: '查看备注',
      Physical: '实体礼物',
      Virtual: '虚拟礼物',
      Processed: '已处理',
      LogisticCompany: '物流公司：',
      ShipmentNumber: '物流单号：',
    },
    PointRecord: {
      UserCenter: '个人中心',
      GiftCenter: '礼品中心',
      PointRecord: '积分记录',
      GiftName: '礼品名称',
      PointExchange: '积分变化',
      BeforeRedemption: '变动前',
      AfterRedemption: '变动后',
      RedemptionTime: '变动时间',
      Physical: '实体礼物',
      Virtual: '虚拟礼物',
      Processed: '已处理',
      Unprocessed: '未处理',
      type: '类型',
    }
  },
  Shopping: {
    Cart: {
      OrderCart: '订单购物车',
      QuotationCart: '报价单购物车',
      ProductInfo: '商品信息',
      Price: '单价',
      Quantity: '数量',
      Amount: '总价',
      Action: '操作',
      Delete: '删除',
      Total: '共',
      Item: '件',
      GrandPrice: '合计',
      DeleteSelected: '删除选中',
      Checkout: '结算',
      SelectOneItem: '请选择至少一个物品',
      Cancel: '取消',
      Confirm: '确认',
      DeleteItem: '确认删除此商品吗？',
      ItemRemoved: '已从购物车删除!',
      DeleteSelectedConfirm: '确认删除选中商品吗？',
      SelectedDeleted: '已删除选中项',
      Quote: '报价',
    }
  },
  Address: {
    ManageAddress: {
      AddAddress: '新增地址',
      Recipient: '收件人',
      Phone: '电话',
      Address: '地址',
      Action: '操作',
      DefaultAddress: '默认地址',
      Delete: '删除',
      SetDefault: '设为默认',
      Default: '默认',
      DeleteAddress: '是否删除本地址？此操作无法撤销！',
      Cancel: '取消',
      Confirm: '确认',
      AddressDeleted: '地址已删除！',
      Modify: '修改'
    },
    SetAddress: {
      AddAddress: '新增地址',
      ChangeAddress: '修改地址',
      Recipient: '收件人',
      RecipientPholder: '收件人姓名',
      Phone: '电话',
      PhonePholder: '请输入您的电话号码',
      Country: '国家',
      SelectCountry: '请选择国家',
      Province: '省',
      SelectProvince: '请选择省',
      City: '市',
      SelectCity: '请选择市',
      Area: '街区',
      SelectArea: '请选择区县',
      DetailedAddress: '详细地址',
      DAPholder: '请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等信息',
      DefaultAddress: '默认地址',
      No: '否',
      Yes: '是',
      Add: '添加',
      Modify: '修改',
      CompleteAll: '请确认输入内容填写完整',
      InvalidPhone: '手机号码有误',
      AddAddressSuccess: '地址添加成功',
      ModifyAddressSuccess: '地址修改成功',
    }
  },
  Order: {
    OrderCenter: {
      Reminder: '暂时没有任何订单，去产品中心逛一逛吧！',
      ClickRedirect: '点击跳转',
      OrderNumber: '订单号',
      TotalPrice: '总价',
      OrderStatus: '订单状态',
      WaitQuote: '等待报价',
      ReturnPoints: '返积分',
      PaymentMethod: '购买方式',
      Action: '操作',
      CancelOrder: '取消订单',
      Refund: '申请退款',
      DeleteOrder: '删除订单',
      Point: '积分',
      Price: '单价',
      Quantity: '数量',
      SelectPayMethod: '请选择支付方式',
      Alipay: '支付宝',
      Cancel: '取消',
      Confirm: '确认',
      Unpaid: '未付款',
      Paid: '已付款',
      Shipped: '已发货',
      Received: '已签收',
      Cancelled: '订单取消',
      Refunded: '退货退款',
      Online: '在线购买',
      Prepaid: '预付费',
      Quotation: '报价购买',
      Pending: '待处理',
      Processed: '已处理',
      Rejected: '预付款拒绝',
      CancelOrderConfirm: '确认取消此订单？',
      OrderCancelled: '订单已取消!',
      DeleteOrderConfirm: '确认删除此订单？',
      OrderDeleted: '删除成功!',
      ClickPay: '点击付款',
      OutOfStock:'缺货',
      RefundConfirm: '确认退款？',
    },
    OrderConfirm: {
      AddAddress: '新增地址',
      RequestQuote: '申请报价',
      ConfirmOrder: '确认订单',
      SelectAddress: '请选择收货地址',
      ManageAddress: '管理地址',
      ClickSelectAddress: '点击选择地址',
      DefaultAddress: '默认地址',
      ShowAllAddress: '显示所有地址',
      Order: '订单',
      Name: '名称',
      Price: '价格',
      Price2: '单价',
      Quantity: '数量',
      PaymentMethod: '支付方式',
      Alipay: '支付宝',
      SubmitOrder: '提交订单',
      Total: '共',
      Item: '件',
      GrandPrice: '合计',
      OrderSubmitted: '订单已成功提交！'
    }
  },
  Contact: {
    ContactUs: '联系我们',
    Name: '姓名',
    Email: '邮箱',
    Phone: '电话',
    Message: '留言',
    Swipe: '右滑验证',
    VerSuccess: '验证成功！',
    Send: '发送',
    Sended: '反馈已成功发送！',
    TipVerify: '提示：请通过滑动验证！',
  },
  About: {
    AboutUs: '公司简介',
    Introduce: '<p><br></p><p><span style="font-family:宋体">大松嘉信实业（深圳）有限公司成立于</span><span>2015</span><span style="font-family:宋体">年</span><span>9</span><span style="font-family:宋体">月</span><span>15</span><span style="font-family:宋体">日，是一家集研发与销售的高新技术企业，我们的使命是为不同类型的企业与组织机构提供安全可靠的网络解决方案以及技术支持</span><span>,</span><span style="font-family:宋体">并在网络、无线、远程通信、</span><span>web</span><span style="font-family:宋体">应用程序开发、技术培训和互联网解决方案等领域提供完整的系统集成。</span></p><p><span>&nbsp;</span></p><p><b><span style="font-family:宋体">互联网与网络技术</span></b></p><p><span style="font-family:宋体">我们重点关注的是如何为我们的客户提供更优质的网络系统和咨询服务。互联网技术是我们解决方案的重要组成部分，包括防火墙、负载均衡、故障转移、带宽管理、身份验证系统、</span><span>VoIP</span><span style="font-family:宋体">、传感器、远程管理、集成邮件、</span><span>web</span><span style="font-family:宋体">站点开发以及各种新技术，如虚拟专用网络</span><span>(VPN)</span><span style="font-family:宋体">。我们非常重视互联网的发展，并花大量时间与大大小小的同行企业保持同步。我们的业务是了解谁在下的通信技术领域提供最好的服务，从设备、软件到互联网提供商，以及数据通信运营商，如电话公司和相关行业提供商。</span></p><p><span>&nbsp;</span></p><p><span style="font-family:宋体">我们成立时就在局域网（</span><span>LAN</span><span style="font-family:宋体">）和广域网（</span><span>WAN</span><span style="font-family:宋体">）领域取得很好的成就，后来开始提供互联网集成服务。作为网络操作系统和网络硬件的分销商和经销商，我们已经成功实施了业界顶尖公司的解决方案，包括</span><span>Cambium</span><span style="font-family:宋体">、</span><span>Mikrotik</span><span style="font-family:宋体">、</span><span>Ubiquiti</span><span style="font-family:宋体">、</span><span>Cisco</span><span style="font-family:宋体">、</span><span>Ruckus</span><span style="font-family:宋体">、</span><span>Huawei</span><span style="font-family:宋体">、</span><span>OkPortal</span><span style="font-family:宋体">等。我们在这一领域提供产品和服务，也提供硬件和软件的定制或开发，从纯粹的咨询和设计工作，到完成安装和集成服务。我们的目标是帮助客户更好地了解所用的技术，使他们能够更好地管理自己的技术资源。</span></p><p><span>&nbsp;</span></p><p><b><span style="font-family:宋体">我们的服务和技术解决方案</span></b></p><p><span style="font-family:宋体">下面是我们提供的解决方案和服务的概要。我们专注于网络和通信领域的相关技术，并提供软件和应用程序开发服务。</span></p><p><b><span style="font-family:宋体">系统集成与支持</span></b></p><p><span style="font-family:宋体">•局域网和广域网</span></p><p><span style="font-family:宋体">•网络规划和设计</span></p><p><span style="font-family:宋体">•系统安装与支持</span></p><p><span style="font-family:宋体">•无线数据通信</span></p><p><span style="font-family:宋体">•网络系统编程</span></p><p><span style="font-family:宋体">•远程通信支持</span></p><p><span style="font-family:宋体">•传感器数据网络通信</span></p><p><span style="font-family:宋体">•机器人、无人机、</span><span>LED</span><span style="font-family:宋体">网络通信</span></p><p><span style="font-family:宋体">•闭路电视网络</span></p><p><span style="font-family:宋体">•光纤设计、安装和支持</span></p><p><span>&nbsp;</span></p><p><b><span style="font-family:宋体">互联网解决方案</span></b></p><p><span style="font-family:宋体">•互联网咨询和支持</span></p><p><span style="font-family:宋体">•防火墙和网络安全</span></p><p><span style="font-family:宋体">•带宽管理植入</span></p><p><span style="font-family:宋体">•负载均衡和故障转移</span></p><p><span style="font-family:宋体">•</span><span>Wi-Fi</span><span style="font-family:宋体">登录验证</span></p><p><span style="font-family:宋体">•</span><span>Wi-Fi</span><span style="font-family:宋体">营销</span></p><p><span style="font-family:宋体">•电子邮件集成</span></p><p><span style="font-family:宋体">•</span><span>Web</span><span style="font-family:宋体">网站开发</span></p><p><span style="font-family:宋体">•互联网技术培训</span></p><p><span style="font-family:宋体">•企业网络桥接</span></p><p><span>&nbsp;</span></p><p><b><span style="font-family:宋体">商业信息系统支持</span></b></p><p><span style="font-family:宋体">•信息系统定制</span></p><p><span style="font-family:宋体">•灾难恢复</span></p><p><span style="font-family:宋体">•硬件和软件评估</span></p><p><span style="font-family:宋体">•定制培训服务</span></p><p><b><span>&nbsp;</span></b></p><p><b><span style="font-family:宋体">应用程序和软件开发</span></b></p><p><span style="font-family:宋体">•分析和设计</span></p><p><span style="font-family:宋体">•软件编程服务</span></p><p><span style="font-family:宋体">•组件咨询和开发</span></p><p><span style="font-family:宋体">•网站和网络数据库应用开发</span></p><p><span style="font-family:宋体">•灾备</span></p><p><span style="font-family:宋体">•联系人管理和客户关系管理</span></p><p><span>&nbsp;</span></p><p><b><span style="font-family:宋体">客户类型</span></b></p><p><span style="font-family:宋体">我们为各种行业提供服务，以下是我们帮助过的部分行业列表：</span></p><p><span style="font-family:宋体">•制造业和工业</span></p><p><span style="font-family:宋体">•医疗保健</span></p><p><span style="font-family:宋体">•酒店和餐饮业</span></p><p><span style="font-family:宋体">•批发零售业</span></p><p><span style="font-family:宋体">•苗圃景观</span></p><p><span style="font-family:宋体">•教育机构</span></p><p><span style="font-family:宋体">•物流业</span></p><p><span style="font-family:宋体">•维修服务业</span></p><p><span style="font-family:宋体">•政府机构</span></p><p><span style="font-family:宋体">•非营利机构</span></p><p><span style="font-family:宋体">我们知道每个组织都是独一无二的，因此我们努力给客户最合适的定制化解决方案，而不是销售一个热销但并不适合客户的产品。我们将根据客户的需求开发系统，凭借在集成和定制方面的经验，再加上独特的产品，我们可以满足客户的需求。</span></p><p><span>&nbsp;</span></p><p><span>&nbsp;</span></p><p><span>&nbsp;</span></p><p><span>&nbsp;</span></p><p><span>&nbsp;</span></p><p><b><span style="font-family:宋体">企业文化</span><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></b></p><p><span style="font-family: 宋体">使命：为客户实现利益最大化</span></p><p><span style="font-family: 宋体">愿景：让互联网更安全</span></p><p style="text-indent: 48px"><span style="font-family:宋体">让我们<span style="color:red">（大松嘉信）</span>成为客户最值得信赖的伙伴</span></p><p><span style="font-family: 宋体">价值观：服务客户，不断创新，持续发展</span></p><p><span>&nbsp;</span></p><p><br></p>',
  },
  Login: {
    AccountLogin: '账号登录',
    ID: '账号',
    IDph: '手机号码/邮箱',
    Pwd: '密码',
    PwdPh: '请输入您的密码',
    Remember: '记住密码',
    Forgot: '忘记密码？',
    Login: '登录',
    RegHere: '没有账号？点击注册',
    Empty: '请确认输入内容不为空',
    LoginSuccess: '登录成功！',
    LoginError: '用户名或者密码错误',
  },
  Signup: {
    AccountSignup: '账号注册',
    SelCountry: '选择国家',
    SCph: '请选择国家',
    SelProvince: '选择省份',
    SPph: '请选择省份',
    Email: '邮箱',
    Emailph: '请输入邮箱',
    Phone: '手机号码',
    Phoneph: '请输入手机号码',
    Vercode: '验证码',
    VCph: '请输入验证码',
    SendVC: '发送验证',
    Pwd: '密码',
    Pwdph: '请输入您的密码',
    CPwd: '确认密码',
    Name: '用户名',
    InviteCode: '邀请码（选填）',
    ICph: '邀请码',
    Signup: '注册',
    LogHere: '已有账号？点击登录',
    InvalidEmail: '请输入正确的邮箱',
    InvalidPhone: '请输入正确的手机号码',
    TimeResend: '秒后重发',
    Comitting: '正在注册，请勿重复提交',
    Empty: '请确认输入内容不为空',
    CPwdInvalid: '密码确认输入不一致',
    Success: '注册成功！',
    AgreeTerm:'请先点击同意协议条款',
    Terms:'同意协议条款',
    Agree:'同意',
  },
  Training: {
    Home: '首页',
    TrainingInfo: '培训信息',
    Intro: '为了加快理解RouterOS-Mikrotik设备和Ubiquiti设备，EDCwifi－捷联讯通科技有限公司首先在中国 建立一个认证培训合作伙伴，通过这样的活动可以认识有兴趣使用Mikrotik或Ubiquiti的人。EDCwifi被Mikrotik 和Ubiquiti授权为认证培训合作伙伴，具备举办培训活动的资格，并制作正式的Mikrotik和Ubiquiti注册登记证书。',
    CheckCertificate: '点击检查证书',
    CertiTraining: '认证培训',
    MikIntro: 'MikroTik培训班由世界各地的MikroTik培训中心组织和提供。他们由网络工程师，集成商和经理参加，他们想了解有关使用MikroTik RouterOS进行有线和无线网络的路由和管理。',
    TrainingContent: '培训内容',
    UBNTintro: '我们致力于为全球的 Ubiquiti® 客户提供专业品质的培训。我们设计了由Ubiquiti 认证培训合作伙伴传授、由Ubiquiti 认证培训师举办的课程。',
    UBNTintro2: '每期课程均由学生使用实际设备，将培训师指导的陈述和实践练习结合在一起。我们发现，大多数技术人员通过观察和实践能学得很好，因此我们结合了大量的图形、视觉和触觉实验练习，加强您的学习。',
    CertiTrainer: 'MikroTik和Ubiquiti认证培训讲师',
    CertiTrainer2: 'MikroTik认证培训讲师',
    CTen: 'Certification Training',
    TCen: 'Training Content',
    SenLecturer: '资深讲师',
    SLen: 'Senior Lecturer',
    TIen: 'Training Information',
    Time: '时间',
    Address: '地址',
    Fees: '培训费用',
    ContactNumber: '联系电话',
    Deadline: '报名截止时间',
    Trainer2: '吴老师',
    Trainer3: '陈老师',

    Mikpop: [{
      title: 'MikroTik—MTCNA 网络助理认证培训',
      list: [
        'Mikrotik 介绍 基本TCP/IP',
        'RouterOS 基本设置',
        'ROS安装',
        '防火墙过滤、NAT',
        'QOS、简单队列',
        '防火墙标记',
        '无线基本设置',
        '网桥、EOIP',
        'WDS',
        '静态路由、基本OSPF',
        'DHCP、Hotspot',
        'VPN',
        '代理',
        'MTCNA 考试'
      ]
    },
    {
      title: 'MikroTik—MTCTCE 流量管理认证工程师',
      list: [
        '基本配置',
        'DHCP、代理',
        '二层安全',
        '防火墙过滤、NAT、标记',
        'L7协议',
        'QOS队列',
        'MTCTCE 考试'
      ]
    },
    {
      title: 'MikroTik—MTCWE 高级无线认证工程师认证',
      list: [
        '无线基础',
        '无线工具和基本配置',
        '无线高级配置',
        '访问管理和虚拟AP（VAP）',
        '无线安全',
        'WDS',
        'RouterOS MESH',
        'Nstreme双工无线',
        'RouterOS-802.11N规则安装',
        'MPLS和VPLS网桥',
        'NV2协议',
        'MTCWE考试',
      ]
    },
    {
      title: 'MikroTik—MTCRE 高级路由认证工程师认证',
      list: [
        '简单路由',
        '策略路由',
        'OSPF',
        ' RIP',
        'VLAN',
        'IP Tunnel',
        'MME MESH',
        '动手操作',
        'MTCRE(高级路由)考试',

      ]
    }],
    Ubntpop: [{
      title: 'Ubiquiti UEWA（Ubiquiti 企业无线管理）',
      list: [
        'WLAN 基本原理',
        'WLAN 规划',
        'UAP布署',
        'UAP基本采用&amp;设置',
        '分析',
        '高级管理',
        '来宾网络&amp;Portal与热点',
        'UEWA Online考试',

      ]
    },
    {
      title: 'Ubiquiti UBWA（Ubiquiti宽带无线管理课程）',
      list: [
        'RF THEORY',
        '无线电操作原理',
        '无线电调制',
        '天线',
        'Airmax和Ubiquiti特征',
        '2层和3层 无线ISP解决方案',
        'UBWA Online考试',

      ]
    },
    {
      title: 'Ubiquiti UBWS（Ubiquiti宽带无线入门课程）',
      list: [
        '服务提供商网络简介',
        'airCAM云套件概述',
        '配置点对点网络',
        '配置点对多点网络',
        '使用airOS-7工具套件进行实战',
        '客户端和AP的最佳做法',
        'UBWS Online考试',

      ]
    }]
  },
  Resources: {
    Resources: '资源',
    Search: '搜索',
  },
  Solutions:{
    All:'全部案例',
  },
  Products:{
    Search: '搜索商品',
    All:'全部',
    Quote:'申请报价',
    Purchase:'立即购买',
    AddCart:'加入购物车',
    Details:{
      Label:'标签',
      Desc:'产品描述',
      View:'查看',
      Specs:'规格',
      APSpecs:'接入点规格',
      SimilarProducts:'相似产品',
      AddedCart:'已添加至购物车',
      QuotedCart:'成功添加至报价单购物车',
    },
    NoRecomm:'暂无相似推荐',
    DownloadPdf:'下载PDF',
    RequestQuote:'申请报价',
  },
  Home:{
    Brand:'品牌',
    HotProducts:'热门产品',
    Solutions: '案例',
    News:'新闻',
    Readmore:'阅读更多',
    Video: '视频',
  },
  News:{
    MostView:'最多浏览',
    Related:'相关文章',
    AllNews: '所有新闻'
  },
  OrderDetail:{
    detail:'订单详情',
    addr:'收货地址',
    createtime:'下单时间',
    ordersn:'订单编号',
    buytype:'购买方式',
    orderstatus:'订单状态',
    paytime:'付款时间',
    LogisticsCompany:'物流公司',
    LogisticsNo:'单号',
    Ucan:'您可以',
    waitprice:'等待报价',
    ProductName:'商品',
    Price:'单价',
    Number:'数量',
    Points:'积分',
    TotalPrice:'总价',
    Payment:'实付',
    BackOrderCenter:'返回',




  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js